import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

export const fetchTicketsAnnules = ({ dateFrom, dateTo, filter, scope, tirageFrom, tirageUp }) =>
  apiRequest(`/tickets/tickets-annules/${toQuery({
    date_from: dateFrom, date_to: dateTo, filter, scope, tirage_from: tirageFrom, tirage_up: tirageUp,
  })}`);
